import Promise from 'promise-polyfill';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import Vuex from 'vuex';

if (!window.Promise) {
  window.Promise = Promise;
}

Vue.use(VueI18n);
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navbarVisible: false,
    i18n: new VueI18n({
      locale: (() => {
        if (/bot|crawler|spider|crawling/i.test(navigator.userAgent)) {
          return 'hu';
        }

        const language = localStorage.getItem('language');

        if (language) {
          return language;
        }

        if (navigator.language.includes('hu')) {
          return 'hu';
        }

        if (navigator.language.includes('de')) {
          return 'de';
        }

        return 'en';
      })(),
    }),
  },
  mutations: {
    setNavbarVisibility(state, visible) {
      state.navbarVisible = visible;
    },
    setLocale(state, locale) {
      localStorage.setItem('language', locale);
      state.i18n.locale = locale;
    },
  },
  actions: {
    sendSurveyReqMail: async function sendSurveyReqMail(context, payload) {
      try {
        await window.emailjs
          .send(
            'default_service',
            'landingpage_survay_req',
            payload);

        return true;
      } catch (error) {
        return false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/store.js